import { Team } from "../../models";

var moment = require("moment");

/**
 * Sorts the teams from newest to oldest
 * 
 * @param data 
 * @returns teams sorted from newest to oldest
 */
export function sortTeamsByCreatedDate(data: Team[]) {
    try {
        let result: Team[] = [];
        if (data && data.length) {
            result = data.sort((a,b) => new moment(b.createdOn).format("YYYYMMDDHHmmss") - new moment(a.createdOn).format("YYYYMMDDHHmmss"));
        }
        return result;
    } catch (error: any) {
        console.error("Error sorting data for type: team");
        console.error(error);
        return null;
    }
};